import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { useDebounce } from 'shared/hooks/useDebounce'

import { getCryptoEstimateAmount } from 'features/payment/actions'

interface IUseConvertAmount {
  amount: string | number
  currencyFrom?: string
  currencyTo?: string
}

export const useConvertAmount = ({ amount, currencyFrom, currencyTo }: IUseConvertAmount) => {
  const dispatch = useDispatch()

  const debouncedAmount = useDebounce(amount, 500)

  useEffect(() => {
    if (debouncedAmount && currencyFrom && currencyTo) {
      dispatch(getCryptoEstimateAmount({ amount: +debouncedAmount, currencyFrom, currencyTo }))
    }
  }, [debouncedAmount])
}
